<template>	
	<div class="entity-manage">
		<div class="menu-tree">
			<el-tree v-loading="treeListLoading" :data="entityTree" show-checkbox node-key="id" :default-expand-all="false"
			  draggable ref="treeX" :expand-on-click-node="false">
			  <span class="custom-tree-node" slot-scope="{ node, data }">
			    <!-- <div class="menu-item"> -->
			    <span>{{ data.cur.name }}</span>
			    <span>
			      <!-- v-if="data.children!=undefined&&data.children.length!=0 || data.parentid == 0 && data.url == ''" -->
			      <el-button plain type="success" size="mini" @click="() => handleNew(node,data)" >
			        新建
			      </el-button>
			      <el-button plain type="danger" size="mini" @click="() => handleDelete(node, data)" v-show="data.children.length == 0">
			        删除
			      </el-button>
			      <el-button plain type="primary" size="mini" @click="() => handleEdit(node, data)">
			        编辑
			      </el-button>
				  <el-button plain type="success" size="mini" @click="() => handleNewAdmin(data.cur)">
				    新建管理员
				  </el-button>
				  <el-button plain type="warning" size="mini" @click="() => handlePause(data.cur)" v-if="data.cur.isUse == 0">
				    暂停运营
				  </el-button>
				  <el-button plain type="success" size="mini" @click="() => handlePause(data.cur)" v-if="data.cur.isUse == 2">
				    启用
				  </el-button>
			    </span>
			    <!-- </div> -->
			  </span>
			</el-tree>
		</div>	
			
		<!-- 新建(编辑)运营单位 -->
		<el-dialog :visible.sync="formEntityVisable" :title="dialogType ==='edit'?'编辑运营单位':'新建运营单位'">
		  <el-form :model="formEntityData">
		    <el-form-item v-show="true">
			  <!-- 
		      <el-input v-show="true" v-model="formEntityData.editEntityId"></el-input>
			  <el-input v-show="true" v-model="formEntityData.editParentId"></el-input>
			  -->
		    </el-form-item>
		    <el-form-item label="单位名称" label-width="120px" style="width: 180%;">
		      <el-col :span="12">
		        <el-input :value="formEntityData.addEntityName"
		          @input="e => formEntityData.addEntityName = e.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]+$/g,'')" maxlength="20"
		          placeholder="请输入单位名称">
		        </el-input> <!-- v-model="formEntityData.addEntityName" -->
		      </el-col>
		    </el-form-item>
		    <el-form-item label="联系人" label-width="120px" style="width: 180%;">
		      <el-col :span="12">
		        <el-input :value="formEntityData.addContacts"
		          @input="e => formEntityData.addContacts = e.replace(/[^a-zA-Z\u4e00-\u9fa5]+$/g,'')" maxlength="20"
		          placeholder="请输入联系人">
		          <!-- v-model="formEntityData.addContacts" placeholder="请输入联系人" -->
		        </el-input>
		      </el-col>
		    </el-form-item>
		    <el-form-item label="联系方式" label-width="120px" style="width: 180%;">
		      <el-col :span="12">
		        <el-input :value="formEntityData.addPhone" @input="e => formEntityData.addPhone = e.replace(/[^\d-]/g,'')"
		          :maxlength="maxlengthPhone" placeholder="请输入联系方式" @keyup.native="check_phone(1)">
		        </el-input> <!-- v-model="formEntityData.addPhone" placeholder="请输入联系方式" -->
		      </el-col> 
		    </el-form-item>
			<el-form-item label="人工工时" label-width="120px" style="width: 180%;">
			  <el-col :span="10">
			    <el-input :value="formEntityData.addManHour"
			      @input="e => formEntityData.addManHour = e.replace(/[^0-9]+$/g,'')" maxlength="20"
			      placeholder="人工工时">
			    </el-input>
			  </el-col>
			  <el-col :span="2" style="margin-left: 20px">小时/每天</el-col>
			</el-form-item>
				<el-form-item label="描述信息" label-width="120px" style="width: 180%;">
					<el-col :span="12">
						<el-input :value="formEntityData.addDesc"
							@input="e => formEntityData.addDesc = e.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]+$/g,'')" maxlength="300"
							placeholder="请输入描述信息">
						</el-input>
					</el-col>
			</el-form-item>
			<el-form-item label="图片网址" label-width="120px" style="width: 180%;">
					<el-col :span="12">
						<el-input v-model="formEntityData.addNetPic" 
							  maxlength="300" placeholder="请输入图片网址">
						</el-input>
					</el-col>
			</el-form-item>
			<el-form-item label="网站图标" label-width="120px" style="width: 180%;">
					<el-col :span="12">
						<el-input v-model="formEntityData.addLogo" 
							  maxlength="300" placeholder="请输入网站标题">
						</el-input>
					</el-col>
			</el-form-item>
			<el-form-item label="网站标题" label-width="120px" style="width: 180%;">
					<el-col :span="12">
						<el-input v-model="formEntityData.addLogoTit" 
							  maxlength="300" placeholder="请输入网站标题">
						</el-input>
					</el-col>
			</el-form-item>
			<el-form-item label="ADT图标" label-width="120px" style="width: 180%;">
					<el-col :span="12">
						<el-input v-model="formEntityData.addLogoAdt" 
							  maxlength="300" placeholder="请输入网址图标">
						</el-input>
					</el-col>
			</el-form-item>
			<el-form-item label="大屏图标" label-width="120px" style="width: 180%;">
					<el-col :span="12">
						<el-input v-model="formEntityData.addLogoScn" 
							  maxlength="300" placeholder="请输入大屏图标">
						</el-input>
					</el-col>
			</el-form-item>
			<el-form-item label="地址" label-width="120px" style="width: 180%;">
				    <el-col :span="8">
				      <el-input :value="formEntityData.addAddress"
				        @input="e => formEntityData.addAddress = e.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]+$/g,'')" maxlength="20"
				        placeholder="请输入地址">
				        <!-- v-model="formEntityData.addAddress" placeholder="请输入地址" -->
				      </el-input>
				    </el-col>
					<el-col :span="4" style="margin-left: 20px">
						<el-button  size="mini" @click="getLocationByAddress">查询</el-button>
					</el-col>
			</el-form-item>
			<el-form-item label="位置信息" label-width="120px" style="width: 180%;">
					 <el-col :span="12">
						 <p>{{formEntityData.addLng}}, {{formEntityData.addLat}}</p>
					 </el-col>
					 <div>  	
						 <baidu-map class="bm-view" :center="BMapCenter" scroll-wheel-zoom @ready="bm_ready"
							 @zoomend="bm_zoomend" :zoom="19" :continuous-zoom="false">
						</baidu-map>
					 </div>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="footer">
		    <el-button @click="formEntityVisable = false">取消</el-button>
		    <el-button type="primary" @click="addEntityFormData()">确定</el-button>
		  </div>
		</el-dialog>
		
		<!-- 弹出【新建管理员】编辑框 -->
		<el-dialog title="新建管理员" :visible.sync="formAdminVisable">
		  <el-form :model="formAdminData">
		    <el-form-item label="用户名" label-width="120px">
		      <el-col :span="12">
		        <el-input :value="formAdminData.username"
		          @input="e => formAdminData.username = e.replace(/[^_0-9a-zA-Z]/g,'')" maxlength="20" placeholder="请输入用户名">
		        </el-input> <!-- v-model="formAdminData.username" -->
		      </el-col>
		    </el-form-item>
		    <el-form-item label="密码" label-width="120px">
		      <el-col :span="12">
		        <el-input v-model="formAdminData.password" maxlength="20"
		          @input="e => formAdminData.password = e.replace(/[^0-9a-zA-Z]+$/g,'')" show-password placeholder="请输入密码">
		        </el-input>
		      </el-col>
		    </el-form-item>
		    <el-form-item label="确认密码" label-width="120px">
		      <el-col :span="12">
		        <el-input v-model="formAdminData.rePassword" maxlength="20"
		          @input="e => formAdminData.rePassword = e.replace(/[^0-9a-zA-Z]+$/g,'')" show-password
		          placeholder="请再次输入密码"></el-input>
		      </el-col>
		    </el-form-item>
		    <el-form-item label="所属单位" label-width="120px">
		      <el-col :span="12">
		        <el-input v-model="formAdminData.entityName" :disabled="true">
		        </el-input>
		      </el-col>
		    </el-form-item>
		    <el-form-item v-show="false">
		      <el-input v-model="formAdminData.entityId"></el-input>
		    </el-form-item>
		    <el-form-item label="角色" label-width="120px">
		      <el-col :span="12">
		        <!-- <el-input v-model="formAdminData.roleName">
		      </el-input> -->
		        <el-select v-model="formAdminData.roleId" placeholder="请选择角色">
		          <el-option v-for="item in roleIdOptions" :key="item.value" :label="item.label" :value="item.value">
		          </el-option>
		        </el-select>
		      </el-col>
		    </el-form-item>
		    <el-form-item label="联系方式" label-width="120px">
		      <el-col :span="12">
		        <el-input :value="formAdminData.phone" @input="e => formAdminData.phone = e.replace(/[^\d]/g,'')"
		          :maxlength="maxlengthPhone" placeholder="请输入联系方式" @keyup.native="check_phone(2)">
		          <!-- v-model="formAdminData.phone" -->
		        </el-input>
		      </el-col>
		    </el-form-item>
		  </el-form>
		
		  <div slot="footer" class="footer">
		    <el-button @click="formAdminVisable = false">取消</el-button>
		    <el-button type="primary" @click="addAdminFormData()">确定</el-button>
		  </div>
		</el-dialog>		
			
	</div>		
</template>

<script>
	import {getEntityTree,addEntity ,pauseEntity,deleteEntity} from '@/api/entity.js'
	import {formatDate} from '@/utils/date'
	import {addUser} from '@/api/user.js'
	import {getRoles} from '@/api/role.js'
	
	export default {
		 data() {	 
		   return {
			   curEntityId:this.$store.getters['user/entityId'],
			   treeListLoading:true,
			   entityTree:[],
			   
			   formEntityVisable: false,
			   formEntityData: {
				   parentId:'',
			       addEntityName: '',
			       addAddress: '',
			       addContacts: '',
			       addPhone: '',
				   addManHour:'',
			       editEntityId: '',
				   addDesc:'',
				   addLng:'',
				   addLat:'',
				   addNetPic:'',
				   addLogo:'',
				   addLogoTit:'',
				   addLogoAdt:'',
				   addLogoScn:''
			   },
			   maxlengthPhone: 11,
			   dialogType: 'new',
			   
			   formAdminVisable: false,
			   formAdminData: {
			       username: '',
			       password: '',
			       rePassword: '',
			       entityName: '',
			       // roleName: '',
			       phone: '',
			       entityId: null,
			       roleId: null
			   },
			   roleIdOptions: [],
			   
			   map: undefined,
			   BMap: undefined,
			   BMapCenter:{lat: 31.498488, lng: 120.373433}
		   }
		},
		mounted() {
		  this.handleInit()
		},
		methods:{
			handleInit() {
			  this.treeListLoading = true
			  getEntityTree(this.$store.getters['user/entityId']).then(res => {
			    if (res.result === "0") {
			      this.$message({
			        message: res.message,
			        type: 'success'
			      })
			    } else {
			      this.$message.error(res.message)
			    }
				//let treelst = this.treeDataTrans(res.entity)
				let entityAll = []
				entityAll.push(res.entity)
			    this.entityTree = entityAll
			    this.treeListLoading = false
			  })
			},
			treeDataTrans(item) {
			  let res = {
			    id: item.cur.id,
			    name: item.cur.name,
			    parentid: item.cur.parentId,
			    children: []
			  }
			  for (let child of item.subEntity) {
			    res.children.push(this.treeDataTrans(child))
			  }
			  return res
			},
			/**
			 * @param {Object} done
			 * 点击新建框外提示
			 */
			handleClose(done) {
			  this.$confirm('确认关闭？')
			    .then(_ => {
			      done();
			    })
			    .catch(_ => {});
			},
			/**
			 * handleCreate新建运营单位弹出框
			 */
			handleNew(node,data) {
				let row = data.cur
			  this.clearEntity();
			  this.formEntityData.editParentId = row.id
			  this.dialogType = 'new';
			  this.formEntityVisable = true;
			  this.error_input = false
			},
			/**
			  * editEntity编辑运营单位弹出框
			  */
			handleEdit(node,data) {
				let row = data.cur
			    this.formEntityData.editEntityId = row.id
				this.formEntityData.editParentId = row.parentId
			    this.formEntityData.addEntityName = row.name
			    this.formEntityData.addAddress = row.address
			    this.formEntityData.addContacts = row.contacts
			    this.formEntityData.addPhone = row.phone
				this.formEntityData.addManHour = row.manHour
				this.formEntityData.addDesc = row.desc
				this.formEntityData.addNetPic = row.netPic
				this.formEntityData.addLng = row.longitude
				this.formEntityData.addLat =  row.latitude
				this.BMapCenter = {lat:row.latitude,lng:row.longitude}
				this.formEntityData.addLogo = row.logo
				this.formEntityData.addLogoTit  = row.logoTitle
				this.formEntityData.addLogoAdt = row.logoMenuAdt
				this.formEntityData.addLogoScn = row.logoMenuScn
				
			    this.dialogType = 'edit';
			    this.formEntityVisable = true;
			    this.error_input = false
			},
			/**
			 * addAdmin新增管理员弹出框
			 */
			handleNewAdmin(row) {
			  this.clearAdmin()
			  // 运营单位名称不能变
			  this.formAdminData.entityName = row.name
			  this.formAdminData.entityId = row.id
			  // 获取当前运营单位下的role，供新建的用户选择
			  getRoles(this.$store.getters['user/entityId']).then(res => {
			    console.log(res)
			    // TODO 具体操作还要添加
			    let roles = res.data;
			    this.roleIdOptions = roles.map(item => {
			      return {
			        value: item.id,
			        label: item.name
			      }
			    })
			  })
			  this.formAdminVisable = true
			},
			/**
			   * addEntityformData新建(编辑）运营单位
			*/
			addEntityFormData() {
			    this.check_inputs()
			    if (!this.error_input) {
			      addEntity(this.formEntityData).then(res => {
			        if (res.result == '1') {
			          this.$alert('新增成功');
			          this.handleInit();
			          this.formEntityVisable = false;
			          // 更新本地存入的entity
			          this.$store.dispatch('user/getEntity')
			        } else if (res.result == '2') {
			          this.$alert('编辑成功');
			          this.handleInit();
			          this.formEntityVisable = false;
			        } else {
			          this.$alert(res.message);
			        }
			      })
			    }
			},
			
			/**
			* formAdminDataSub新增管理员
			*/
			addAdminFormData() {
			    this.check_inputs_admin()
			    if (!this.error_input) {
			      addUser(this.formAdminData).then(res => {
			        if (res.result === "1") {
			          this.$message({
			            message: res.message,
			            type: 'success'
			          })
			          this.formAdminVisable = false
			        } else if (res.result === "0") {
			          this.$message({
			            message: res.message,
			            type: 'info'
			          })
			        } else {
			          this.$message.error(res.message)
			        }
			      })
			    }
			},
			/**
			 * pauseEntity部门暂停运营
			 */
			handlePause(row) {
			  let alertContent;
			  if (row.isUse === 0) {
			    alertContent = '暂停使用'
			  } else {
			    alertContent = '启用'
			  }
			  this.$confirm('确定要' + alertContent + '吗？', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			    pauseEntity(row.id).then(res => {
			      if (res.result == '0') {
			        this.$alert('操作成功');
			        // 更新本地存入的entity
			        this.$store.dispatch('user/getEntity')
			        this.handleInit();
			      } else {
			        this.$alert(res.message);
			      }
			    })
			  })
			},
			
			/**
			 * deleteEntity部门删除
			 */
			handleDelete(node , data ) {
			  let row = data.cur
			  if (row.id === 1) {
			    this.$alert('本运营单位不允许删除');
			    return
			  } else {
			    if (row.isUse === 0) {
			      alert("启用中的运营点不允许删除！")
			    } else {
			      this.$confirm('确定要删除吗？', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			      }).then(() => {
			        deleteEntity(row.id).then(res => {
			          if (res.result == '0') {
			            this.$alert('删除成功');
			            // 更新本地存入的entity
			            this.$store.dispatch('user/getEntity')
			            this.handleInit();
			          } else {
			            this.$alert(res.message);
			          }
			        })
			      }).catch(e => e)
			    }
			  }		
			},
			/**
			 * clearEntity清除运营单位输入框
			 */
			clearEntity() {
			  this.formEntityData.editEntityId = ''
			  this.formEntityData.addEntityName = ''
			  this.formEntityData.addAddress = ''
			  this.formEntityData.addContacts = ''
			  this.formEntityData.addPhone = ''
			},
			
			/**
			 * clearAdmin清除管理员输入框
			 */
			clearAdmin() {
			  this.formAdminData.username = ''
			  this.formAdminData.password = ''
			  this.formAdminData.rePassword = ''
			  this.formAdminData.entityId = ''
			  this.formAdminData.entityName = ''
			  this.formAdminData.roleId = ''
			  this.formAdminData.phone = ''
			},
			
			/**
			 * entity_input空值校验
			 */
			check_inputs() {
			  this.error_input = false;
			  if (this.formEntityData.addEntityName === '') {
			    this.$alert('运营单位未填写，请核对后再提交')
			    this.error_input = true
			    return
			  }
			  if (this.formEntityData.addAddress === '') {
			    this.$alert('地址未填写，请核对后再提交')
			    this.error_input = true
			    return
			  }
			  if (this.formEntityData.addContacts === '') {
			    this.$alert('联系人未填写，请核对后再提交')
			    this.error_input = true
			    return
			  }
			  if (this.formEntityData.addPhone === '') {
			    this.$alert('联系方式未填写，请核对后再提交')
			    this.error_input = true
			    return
			  }
			  let reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/; //校验手机号和固定电话
			  if (!reg.test(this.formEntityData.addPhone)) {
			    this.$alert('请输入正确的联系方式')
			    this.error_input = true
			    return
			  }
			},
			/**
			 * admin_input空值校验
			 */
			check_inputs_admin() {
			  this.error_input = false;
			  if (this.formAdminData.username === '') {
			    this.$alert('请输入用户名')
			    this.error_input = true
			    return
			  }
			  let d = /^[0-9a-zA-Z_]+$/;
			  if (!d.test(this.formAdminData.username)) {
			    this.$alert('用户名只能是字母、数字和下划线！')
			    this.error_input = true
			    return
			  }
			  if (this.formAdminData.password === '') {
			    this.$alert('请输入密码')
			    this.error_input = true
			    return
			  }
			
			  if (this.formAdminData.rePassword === '') {
			    this.$alert('请输入确认密码')
			    this.error_input = true
			    return
			  }
			
			  if (this.formAdminData.password !== this.formAdminData.rePassword) {
			    this.$alert('密码与确认密码不一致')
			    this.error_input = true
			    return
			  }
			  let z = /^[0-9a-zA-Z@_#]+$/;
			  if (!z.test(this.formAdminData.password) || this.formAdminData.password.length < 4) {
			    this.$alert('密码必须是不小于4个字符的字母、数字或者@_#')
			    this.error_input = true
			    return
			  }
			
			  if (!z.test(this.formAdminData.rePassword) || this.formAdminData.rePassword.length < 4) {
			    this.$alert('确认密码必须是不小于4个字符的字母、数字或者@_#')
			    this.error_input = true
			    return
			  }
			
			  if (this.formAdminData.entityName === '') {
			    this.$alert('所属单位不能为空')
			    this.error_input = true
			    return
			  }
			  if (this.formAdminData.roleId === '') {
			    this.$alert('所属角色不能为空')
			    this.error_input = true
			    return
			  }
			  /* let reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/; //校验手机号和固定电话
			  if (!reg.test(this.formAdminData.phone)) {
			    this.$alert('请输入正确的联系方式')
			    this.error_input = true
			    return
			  } */
			  if (this.error_input === true) {
			    this.$alert('请输入正确的联系方式')
			    return
			  }
			},
			/**
			 * 联系方式校验
			 */
			check_phone(val) {			
			  this.error_input = false;
			  // 运营单位校验
			  if (val == 1) {
			    if (this.formEntityData.addPhone.length == 11 && this.formEntityData.addPhone.indexOf("-") == -1){
			      this.maxlengthPhone = 11;
			    }
			    if (this.formEntityData.addPhone.indexOf("-") != -1) {			
			      this.maxlengthPhone = 13;			
			      let reg = /^((d{3,4})|d{3,4}-|s)?d{7,14}$/;
			      if (!reg.test(this.formEntityData.addPhone)) {			
			        this.error_input = true			
			      }			
			    } else {
			      let reg = /^(1[34578]\d{9})$/;
			      if (!reg.test(this.formEntityData.addPhone)) {
			        
			        this.error_input = true
			      }
			    }			
			  } else {
			    if (this.formEntityData.phone.length == 11 && this.formEntityData.phone.indexOf("-") == -1){
			      this.maxlengthPhone = 11;
			    }
			    if (this.formEntityData.phone.indexOf("-") != -1) {		
			      this.maxlengthPhone = 13;			
			      let reg = /^(0\d{3,4}-\d{7,8})$/;
			      if (!reg.test(this.formAdminData.phone)) {		
			        this.error_input = true		
			      }
			    } else {
			      let reg = /^(1[34578]\d{9})$/;
			      if (!reg.test(this.formAdminData.phone)) {
			
			        this.error_input = true
			
			      }
			    }
			  }			
			},
			/**
			 * 百度地图ready，存储BMap和map对象
			 * @status enable
			 */
			bm_ready({
			  BMap,
			  map
			}) {
			  console.log("BaiduMap is ready")
			  let that = this
			  this.BMap = BMap
			  this.map = map
			  this.map.addEventListener('click', function(e){ //给地图绑定点击事件
			      that.getAddrByPoint(e) //点击后调用逆地址解析函数
			    })
			},
			/**
			 * 百度地图缩放级别改变后触发，该部分主要触发路书的显示，暂时不使用路书
			 * @status enable
			 */
			bm_zoomend({
			  type,
			  target
			}) {
			  //TODO 暂时不做使用
			  return;
			  let zoomNum = target.getZoom()
			  console.log(zoomNum)
			},
			/**
			 * 获取点击坐标
			 */
			getAddrByPoint(cliker){
				console.log("点击了："+cliker.point.lat + "-" + cliker.point.lng)
				this.formEntityData.addLng = cliker.point.lng
				this.formEntityData.addLat = cliker.point.lat
				
				//用所定位的经纬度查找所在地省市街道等信息
				var point_tar = new BMap.Point(cliker.point.lng, cliker.point.lat);
				var gc = new BMap.Geocoder();
				let _this = this;
				gc.getLocation(point_tar, function (rs) {
				    // var addComp = rs.addressComponents;
				    //console.log(rs.address);//地址信息
				    _this.formEntityData.addAddress = rs.address;
				 
				 })						
			},
			
			 // 获取当前地址的经纬度坐标
			async getLocationByAddress() {
				var addr = this.formEntityData.addAddress
				if(addr == '' || addr == null){
					return;
				}
			    try {
			        const point = await this.getPointByAddress(addr);
			        this.BMapCenter = point;
			        console.log('经度：', point.lng);
			        console.log('纬度：', point.lat);			
			      } catch (error) {
			        console.error(error);
			    }
			},
			
			 // 根据地址名称获取经纬度坐标
			getPointByAddress(address) {
			    // 创建地理编码实例
			    const myGeo = new BMap.Geocoder();
			    return new Promise((resolve, reject) => {
			        // 对地址进行地理编码
			        myGeo.getPoint(address, (point) => {
			          if (point) {
			            // 地理编码成功，返回经纬度坐标对象
			            resolve(point);
			          } else {
			            // 地理编码失败
			            reject('地理编码失败');
			          }
			        }, '全国');
			    });
			}
		////////	
		},
	 }
</script>

<style>
	.el-tree-node__content {
	  /* background: #F5F8FA; */
	  height: 50px;
	}
	.custom-tree-node {
	  flex: 1;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  font-size: 14px;
	  padding-right: 8px;
	  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	  height: 40px;
	  padding-left: 10px;
	}
	.bm-view {
	  width: 50%;
	  height: 300px;
	}
</style>
